// UI dictionaries. Data (device models, categories, nicks) is never translated.
// Strings use {placeholders} that callers fill with fmt() from ./index.

export const LOCALES = ["ru", "uk", "en"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "ru";

export const LOCALE_LABELS: Record<Locale, string> = {
  ru: "RU",
  uk: "UK",
  en: "EN",
};

const ru = {
  nav: { dashboard: "Дашборд", assets: "Оборудование", people: "Сотрудники", settings: "Справочники", esim: "eSIM", editor: "Редактор", viewer: "Просмотр", themeSystem: "Тема: как в системе", themeLight: "Тема: светлая", themeDark: "Тема: тёмная" },
  dashboard: {
    title: "Дашборд",
    subtitle: "Обзор оборудования, шифрования и последних операций",
    allEquipment: "Всё оборудование",
    total: "Всего единиц",
    employees: "Сотрудников",
    encryption: "Шифрование диска",
    encryptedOf: "{n} из {m}",
    none: "Без",
    recent: "Последние операции",
    noOps: "Пока нет операций.",
    locationsInRef: "Локаций в справочнике: {n}",
  },
  assets: {
    title: "Оборудование",
    unitsInBase: "{n} единиц в базе",
    add: "Добавить",
    search: "Поиск по тегу, модели, серийнику…",
    allStatuses: "Все статусы",
    allCategories: "Все категории",
    apply: "Применить",
    reset: "Сбросить",
    colTag: "Тег",
    colModel: "Модель",
    colCategory: "Категория",
    colStatus: "Статус",
    colLocation: "Локация",
    colAssignee: "Закреплено за",
    notFound: "Ничего не найдено",
    pageOf: "Страница {p} из {m}",
    prev: "Назад",
    next: "Вперёд",
  },
  detail: {
    breadcrumb: "Оборудование",
    edit: "Редактировать",
    del: "Удалить",
    confirm: "Точно?",
    yesDelete: "Да, удалить",
    cancel: "Отмена",
    specs: "Характеристики",
    serial: "Серийный номер",
    category: "Категория",
    vendor: "Производитель",
    location: "Локация",
    assignee: "Закреплено за",
    purchaseDate: "Дата покупки",
    warranty: "Гарантия до",
    encryption: "Шифрование",
    recoveryId: "Recovery ID",
    recoveryKey: "Ключ восстановления",
    notes: "Заметки",
    operation: "Операция",
    history: "История",
    noHistory: "Операций пока не было.",
    show: "Показать",
    hide: "Скрыть",
    copy: "Копировать",
    copied: "✓ Скопировано",
    editingBreadcrumb: "Редактирование",
  },
  form: {
    newTitle: "Новое оборудование",
    newBreadcrumb: "Новое",
    editTitle: "Редактирование {tag}",
    assetTag: "Инвентарный номер",
    model: "Модель",
    serial: "Серийный номер",
    status: "Статус",
    category: "Категория",
    vendor: "Производитель",
    location: "Локация",
    assignee: "Закреплено за",
    purchaseDate: "Дата покупки",
    warranty: "Гарантия до",
    encSection: "Шифрование диска",
    encType: "Тип",
    recoveryId: "Recovery ID (BitLocker)",
    recoveryKey: "Ключ восстановления",
    notes: "Заметки",
    create: "Создать",
    save: "Сохранить",
    cancel: "Отмена",
    saving: "Сохранение…",
  },
  assign: {
    operation: "Операция",
    employee: "Сотрудник",
    location: "Локация",
    comment: "Комментарий",
    submit: "Записать операцию",
    submitting: "Сохранение…",
  },
  settings: {
    title: "Настройки портала",
    categories: "Категории",
    vendors: "Производители",
    locations: "Локации",
    employees: "Сотрудники",
    name: "Название",
    site: "Площадка",
    room: "Комната",
    addEmployee: "Добавить сотрудника",
    fio: "Ник",
    email: "Email",
    department: "Отдел",
  },
  usearch: {
    title: "Техника у сотрудника",
    placeholder: "Введите ник сотрудника…",
    empty: "Ничего не найдено",
    none: "Техники нет",
    itemsOne: "позиция",
    itemsFew: "позиции",
    itemsMany: "позиций",
  },
  status: { IN_USE: "В работе", SPARE: "На складе", REPAIR: "Ремонт", RETIRED: "Списан" },
  enc: { NONE: "Нет", BITLOCKER: "BitLocker", FILEVAULT: "FileVault" },
  action: { ASSIGN: "Выдача", RETURN: "Возврат", MOVE: "Перемещение", REPAIR: "В ремонт", RETIRE: "Списание" },
  common: { of: "из", dash: "—" },
  people: {
    title: "Сотрудники",
    count: "{n} человек",
    active: "Активные", all: "Все",
    statusActive: "Активен", statusLeft: "Уволен",
    colNick: "Ник", colDept: "Отдел", colEmail: "Почта", colStatus: "Статус", colAccess: "Доступы",
    profile: "Профиль", gps: "GPS", joined: "Дата выхода", left: "Дата увольнения", dateApprox: "дата неточная",
    accounts: "Учётки и номера", noAccounts: "Учёток нет",
    accessTitle: "Доступы", granted: "Выдан", unknown: "Не проверен", revoked: "Закрыт", cabinets: "Кабинеты и роли",
    equipment: "Техника", apple: "Apple ID", noData: "—",
    qrHint: "Открыть QR для заведения", archived: "архив",
    grantedCount: "выдано {n}", unknownCount: "не проверено {n}",
    foundInOtherStatuses: "Ещё {n} подходит под поиск, но в другом статусе (блок или архив).", showAll: "Показать всех",
    add: "Добавить", addTitle: "Новый сотрудник",
    nickHint: "Как в таблице: латиница, нижний регистр", emailHint: "Ключевой признак человека — по ней ищутся дубли",
    createHint: "Остальное можно дозаполнить в карточке",
    deleteWarn: "доступов {g}, техники {a} —",
  },
  access: {
    title: "Доступы — требуют внимания",
    riskyFired: "Уволенных с активным доступом",
    unknownGrants: "Доступов не проверено",
    activeGrants: "Активных доступов",
    onlySd: "Раздел виден только SD",
    openList: "Разобрать",
    stateGranted: "Выдан",
    stateRevoked: "Закрыт",
    stateUnknown: "Не проверен",
    revokeAll: "Отозвать все",
    revokedAll: "все доступы закрыты",
    confirm: "Точно?",
    yes: "Да, отозвать",
    cancel: "Отмена",
    peopleCount: "Людей: {n}",
    grantsCount: "Доступов: {n}",
    allClear: "Всё разобрано",
    addGrant: "Добавить доступ", addGrantSubmit: "Добавить", grantAdded: "Доступ добавлен",
    pickService: "— выберите сервис —", newService: "+ новый сервис…", newServicePlaceholder: "Название: Claude, Fireflies…",
    noAccess: "— нет доступа",
    roleUnset: "доступ есть, роль не указана",
    buckets: {
      offboarded: {
        title: "Уволенные с активным доступом",
        hint: "Сотрудник помечен уволенным, но доступы за ним всё ещё числятся выданными. Закройте их — по одному или кнопкой «Отозвать все».",
        empty: "Ни за одним уволенным не числится активных доступов.",
      },
      unknown: {
        title: "Доступы не проверены",
        hint: "В исходной таблице ячейка была пустой — неизвестно, выдан доступ или нет. Проставьте «Выдан» или «Закрыт».",
        empty: "Непроверенных доступов не осталось.",
      },
      active: {
        title: "Активные доступы",
        hint: "Все выданные доступы. Здесь можно закрыть любой из них при офбординге или смене роли.",
        empty: "Активных доступов нет.",
      },
    },
  },
  esim: {
    title: "eSIM и номера",
    subtitle: "Структура повторяет таблицу «Bip + Esim»: вкладка на каждый лист",
    tabs: { esim: "E-sim", bip: "Bip", eu: "EU", trash: "Мусор", topup: "Пополнить" },
    number: "Номер", qr: "QR", until: "Активен до", purpose: "Под что взят", status: "Статус", drive: "Файл на Google Диске", driveShort: "Диск",
    active: "Активна", pool: "В пуле", archived: "Архив",
    topUp: "Нужно пополнить", topUpShort: "пополнить",
    open: "Открыть", add: "Добавить номер",
    count: "Номеров: {n}",
    searchHint: "Номер / @tg / ник / под что взят",
  },
  status_person: { active: "Активен", blocked: "Блок", left: "Уволен", archive: "Архив", all: "Все" },
  edit: {
    edit: "Изменить", save: "Сохранить", cancel: "Отмена", del: "Удалить", yesDelete: "Да, удалить",
    saved: "Сохранено", deleted: "Удалено",
    handle: "Ник", number: "Номер", label: "Метка", note: "Заметка",
    addAccount: "Добавить учётку", dateExact: "Дата увольнения точная",
  },
  signin: {
    title: "Вход в портал",
    subtitle: "Инвентаризация оборудования · доступ по Google для отдела SD",
    google: "Войти через Google",
    sso: "Войти через Keycloak",
    denied: "Доступ запрещён: ваш аккаунт не входит в список отдела SD.",
    error: "Не удалось войти. Попробуйте ещё раз.",
    signout: "Выйти",
  },
};

export type Dict = typeof ru;

const uk: Dict = {
  nav: { dashboard: "Дашборд", assets: "Обладнання", people: "Співробітники", settings: "Довідники", esim: "eSIM", editor: "Редактор", viewer: "Перегляд", themeSystem: "Тема: як у системі", themeLight: "Тема: світла", themeDark: "Тема: темна" },
  dashboard: {
    title: "Дашборд",
    subtitle: "Огляд обладнання, шифрування та останніх операцій",
    allEquipment: "Усе обладнання",
    total: "Усього одиниць",
    employees: "Співробітників",
    encryption: "Шифрування диска",
    encryptedOf: "{n} з {m}",
    none: "Без",
    recent: "Останні операції",
    noOps: "Поки немає операцій.",
    locationsInRef: "Локацій у довіднику: {n}",
  },
  assets: {
    title: "Обладнання",
    unitsInBase: "{n} одиниць у базі",
    add: "Додати",
    search: "Пошук за тегом, моделлю, серійником…",
    allStatuses: "Усі статуси",
    allCategories: "Усі категорії",
    apply: "Застосувати",
    reset: "Скинути",
    colTag: "Тег",
    colModel: "Модель",
    colCategory: "Категорія",
    colStatus: "Статус",
    colLocation: "Локація",
    colAssignee: "Закріплено за",
    notFound: "Нічого не знайдено",
    pageOf: "Сторінка {p} з {m}",
    prev: "Назад",
    next: "Вперед",
  },
  detail: {
    breadcrumb: "Обладнання",
    edit: "Редагувати",
    del: "Видалити",
    confirm: "Точно?",
    yesDelete: "Так, видалити",
    cancel: "Скасувати",
    specs: "Характеристики",
    serial: "Серійний номер",
    category: "Категорія",
    vendor: "Виробник",
    location: "Локація",
    assignee: "Закріплено за",
    purchaseDate: "Дата покупки",
    warranty: "Гарантія до",
    encryption: "Шифрування",
    recoveryId: "Recovery ID",
    recoveryKey: "Ключ відновлення",
    notes: "Нотатки",
    operation: "Операція",
    history: "Історія",
    noHistory: "Операцій ще не було.",
    show: "Показати",
    hide: "Сховати",
    copy: "Копіювати",
    copied: "✓ Скопійовано",
    editingBreadcrumb: "Редагування",
  },
  form: {
    newTitle: "Нове обладнання",
    newBreadcrumb: "Нове",
    editTitle: "Редагування {tag}",
    assetTag: "Інвентарний номер",
    model: "Модель",
    serial: "Серійний номер",
    status: "Статус",
    category: "Категорія",
    vendor: "Виробник",
    location: "Локація",
    assignee: "Закріплено за",
    purchaseDate: "Дата покупки",
    warranty: "Гарантія до",
    encSection: "Шифрування диска",
    encType: "Тип",
    recoveryId: "Recovery ID (BitLocker)",
    recoveryKey: "Ключ відновлення",
    notes: "Нотатки",
    create: "Створити",
    save: "Зберегти",
    cancel: "Скасувати",
    saving: "Збереження…",
  },
  assign: {
    operation: "Операція",
    employee: "Співробітник",
    location: "Локація",
    comment: "Коментар",
    submit: "Записати операцію",
    submitting: "Збереження…",
  },
  settings: {
    title: "Налаштування порталу",
    categories: "Категорії",
    vendors: "Виробники",
    locations: "Локації",
    employees: "Співробітники",
    name: "Назва",
    site: "Майданчик",
    room: "Кімната",
    addEmployee: "Додати співробітника",
    fio: "Нік",
    email: "Email",
    department: "Відділ",
  },
  usearch: {
    title: "Техніка у співробітника",
    placeholder: "Введіть нік співробітника…",
    empty: "Нічого не знайдено",
    none: "Техніки немає",
    itemsOne: "позиція",
    itemsFew: "позиції",
    itemsMany: "позицій",
  },
  status: { IN_USE: "В роботі", SPARE: "На складі", REPAIR: "Ремонт", RETIRED: "Списано" },
  enc: { NONE: "Немає", BITLOCKER: "BitLocker", FILEVAULT: "FileVault" },
  action: { ASSIGN: "Видача", RETURN: "Повернення", MOVE: "Переміщення", REPAIR: "В ремонт", RETIRE: "Списання" },
  common: { of: "з", dash: "—" },
  people: {
    title: "Співробітники",
    count: "{n} осіб",
    active: "Активні", all: "Усі",
    statusActive: "Активний", statusLeft: "Звільнений",
    colNick: "Нік", colDept: "Відділ", colEmail: "Пошта", colStatus: "Статус", colAccess: "Доступи",
    profile: "Профіль", gps: "GPS", joined: "Дата виходу", left: "Дата звільнення", dateApprox: "дата неточна",
    accounts: "Облікові записи та номери", noAccounts: "Облікових записів немає",
    accessTitle: "Доступи", granted: "Видано", unknown: "Не перевірено", revoked: "Закрито", cabinets: "Кабінети та ролі",
    equipment: "Техніка", apple: "Apple ID", noData: "—",
    qrHint: "Відкрити QR для реєстрації", archived: "архів",
    grantedCount: "видано {n}", unknownCount: "не перевірено {n}",
    foundInOtherStatuses: "Ще {n} підходить під пошук, але в іншому статусі (блок або архів).", showAll: "Показати всіх",
    add: "Додати", addTitle: "Новий співробітник",
    nickHint: "Як у таблиці: латиниця, нижній регістр", emailHint: "Ключова ознака людини — за нею шукаються дублі",
    createHint: "Решту можна дозаповнити в картці",
    deleteWarn: "доступів {g}, техніки {a} —",
  },
  access: {
    title: "Доступи — потребують уваги",
    riskyFired: "Звільнених з активним доступом",
    unknownGrants: "Доступів не перевірено",
    activeGrants: "Активних доступів",
    onlySd: "Розділ бачить лише SD",
    openList: "Розібрати",
    stateGranted: "Видано",
    stateRevoked: "Закрито",
    stateUnknown: "Не перевірено",
    revokeAll: "Відкликати всі",
    revokedAll: "усі доступи закрито",
    confirm: "Точно?",
    yes: "Так, відкликати",
    cancel: "Скасувати",
    peopleCount: "Людей: {n}",
    grantsCount: "Доступів: {n}",
    allClear: "Усе розібрано",
    addGrant: "Додати доступ", addGrantSubmit: "Додати", grantAdded: "Доступ додано",
    pickService: "— оберіть сервіс —", newService: "+ новий сервіс…", newServicePlaceholder: "Назва: Claude, Fireflies…",
    noAccess: "— немає доступу",
    roleUnset: "доступ є, роль не вказана",
    buckets: {
      offboarded: {
        title: "Звільнені з активним доступом",
        hint: "Співробітник позначений звільненим, але доступи за ним досі числяться виданими. Закрийте їх — по одному або кнопкою «Відкликати всі».",
        empty: "За жодним звільненим активних доступів не числиться.",
      },
      unknown: {
        title: "Доступи не перевірено",
        hint: "У вихідній таблиці клітинка була порожня — невідомо, виданий доступ чи ні. Проставте «Видано» або «Закрито».",
        empty: "Неперевірених доступів не залишилось.",
      },
      active: {
        title: "Активні доступи",
        hint: "Усі видані доступи. Тут можна закрити будь-який з них під час офбордингу або зміни ролі.",
        empty: "Активних доступів немає.",
      },
    },
  },
  esim: {
    title: "eSIM і номери",
    subtitle: "Структура повторює таблицю «Bip + Esim»: вкладка на кожен аркуш",
    tabs: { esim: "E-sim", bip: "Bip", eu: "EU", trash: "Сміття", topup: "Поповнити" },
    number: "Номер", qr: "QR", until: "Активний до", purpose: "Під що взято", status: "Статус", drive: "Файл на Google Диску", driveShort: "Диск",
    active: "Активна", pool: "У пулі", archived: "Архів",
    topUp: "Потрібно поповнити", topUpShort: "поповнити",
    open: "Відкрити", add: "Додати номер",
    count: "Номерів: {n}",
    searchHint: "Номер / @tg / нік / під що взято",
  },
  status_person: { active: "Активний", blocked: "Блок", left: "Звільнений", archive: "Архів", all: "Усі" },
  edit: {
    edit: "Змінити", save: "Зберегти", cancel: "Скасувати", del: "Видалити", yesDelete: "Так, видалити",
    saved: "Збережено", deleted: "Видалено",
    handle: "Нік", number: "Номер", label: "Мітка", note: "Нотатка",
    addAccount: "Додати обліковку", dateExact: "Дата звільнення точна",
  },
  signin: {
    title: "Вхід у портал",
    subtitle: "Інвентаризація обладнання · доступ через Google для відділу SD",
    google: "Увійти через Google",
    sso: "Увійти через Keycloak",
    denied: "Доступ заборонено: вашого акаунту немає у списку відділу SD.",
    error: "Не вдалося увійти. Спробуйте ще раз.",
    signout: "Вийти",
  },
};

const en: Dict = {
  nav: { dashboard: "Dashboard", assets: "Equipment", people: "People", settings: "Reference data", esim: "eSIM", editor: "Editor", viewer: "Viewer", themeSystem: "Theme: follow system", themeLight: "Theme: light", themeDark: "Theme: dark" },
  dashboard: {
    title: "Dashboard",
    subtitle: "Overview of equipment, encryption and recent operations",
    allEquipment: "All equipment",
    total: "Total units",
    employees: "Employees",
    encryption: "Disk encryption",
    encryptedOf: "{n} of {m}",
    none: "None",
    recent: "Recent operations",
    noOps: "No operations yet.",
    locationsInRef: "Locations in directory: {n}",
  },
  assets: {
    title: "Equipment",
    unitsInBase: "{n} units in the database",
    add: "Add",
    search: "Search by tag, model, serial…",
    allStatuses: "All statuses",
    allCategories: "All categories",
    apply: "Apply",
    reset: "Reset",
    colTag: "Tag",
    colModel: "Model",
    colCategory: "Category",
    colStatus: "Status",
    colLocation: "Location",
    colAssignee: "Assigned to",
    notFound: "Nothing found",
    pageOf: "Page {p} of {m}",
    prev: "Back",
    next: "Next",
  },
  detail: {
    breadcrumb: "Equipment",
    edit: "Edit",
    del: "Delete",
    confirm: "Sure?",
    yesDelete: "Yes, delete",
    cancel: "Cancel",
    specs: "Specifications",
    serial: "Serial number",
    category: "Category",
    vendor: "Vendor",
    location: "Location",
    assignee: "Assigned to",
    purchaseDate: "Purchase date",
    warranty: "Warranty until",
    encryption: "Encryption",
    recoveryId: "Recovery ID",
    recoveryKey: "Recovery key",
    notes: "Notes",
    operation: "Operation",
    history: "History",
    noHistory: "No operations yet.",
    show: "Show",
    hide: "Hide",
    copy: "Copy",
    copied: "✓ Copied",
    editingBreadcrumb: "Editing",
  },
  form: {
    newTitle: "New equipment",
    newBreadcrumb: "New",
    editTitle: "Editing {tag}",
    assetTag: "Inventory number",
    model: "Model",
    serial: "Serial number",
    status: "Status",
    category: "Category",
    vendor: "Vendor",
    location: "Location",
    assignee: "Assigned to",
    purchaseDate: "Purchase date",
    warranty: "Warranty until",
    encSection: "Disk encryption",
    encType: "Type",
    recoveryId: "Recovery ID (BitLocker)",
    recoveryKey: "Recovery key",
    notes: "Notes",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    saving: "Saving…",
  },
  assign: {
    operation: "Operation",
    employee: "Employee",
    location: "Location",
    comment: "Comment",
    submit: "Record operation",
    submitting: "Saving…",
  },
  settings: {
    title: "Portal settings",
    categories: "Categories",
    vendors: "Vendors",
    locations: "Locations",
    employees: "Employees",
    name: "Name",
    site: "Site",
    room: "Room",
    addEmployee: "Add employee",
    fio: "Nickname",
    email: "Email",
    department: "Department",
  },
  usearch: {
    title: "Equipment by employee",
    placeholder: "Enter employee nickname…",
    empty: "Nothing found",
    none: "No equipment",
    itemsOne: "item",
    itemsFew: "items",
    itemsMany: "items",
  },
  status: { IN_USE: "In use", SPARE: "In stock", REPAIR: "Repair", RETIRED: "Retired" },
  enc: { NONE: "None", BITLOCKER: "BitLocker", FILEVAULT: "FileVault" },
  action: { ASSIGN: "Assign", RETURN: "Return", MOVE: "Move", REPAIR: "To repair", RETIRE: "Retire" },
  common: { of: "of", dash: "—" },
  people: {
    title: "People",
    count: "{n} people",
    active: "Active", all: "All",
    statusActive: "Active", statusLeft: "Left",
    colNick: "Nick", colDept: "Dept", colEmail: "Email", colStatus: "Status", colAccess: "Access",
    profile: "Profile", gps: "GPS", joined: "Joined", left: "Left", dateApprox: "date approximate",
    accounts: "Accounts & numbers", noAccounts: "No accounts",
    accessTitle: "Access", granted: "Granted", unknown: "Not verified", revoked: "Revoked", cabinets: "Cabinets & roles",
    equipment: "Equipment", apple: "Apple ID", noData: "—",
    qrHint: "Open QR to provision", archived: "archived",
    grantedCount: "{n} granted", unknownCount: "{n} unverified",
    foundInOtherStatuses: "{n} more match your search but have another status (blocked or archived).", showAll: "Show all",
    add: "Add", addTitle: "New person",
    nickHint: "As in the spreadsheet: latin, lowercase", emailHint: "The key identifier — duplicates are matched by it",
    createHint: "The rest can be filled in on the card",
    deleteWarn: "{g} grants, {a} devices —",
  },
  access: {
    title: "Access — needs attention",
    riskyFired: "Offboarded with active access",
    unknownGrants: "Access not verified",
    activeGrants: "Active grants",
    onlySd: "Visible to SD only",
    openList: "Review",
    stateGranted: "Granted",
    stateRevoked: "Revoked",
    stateUnknown: "Unverified",
    revokeAll: "Revoke all",
    revokedAll: "all access revoked",
    confirm: "Sure?",
    yes: "Yes, revoke",
    cancel: "Cancel",
    peopleCount: "{n} people",
    grantsCount: "{n} grants",
    allClear: "All clear",
    addGrant: "Add access", addGrantSubmit: "Add", grantAdded: "Access added",
    pickService: "— pick a service —", newService: "+ new service…", newServicePlaceholder: "Name: Claude, Fireflies…",
    noAccess: "— no access",
    roleUnset: "access, role not specified",
    buckets: {
      offboarded: {
        title: "Offboarded with active access",
        hint: "The person is marked as left, yet their access is still recorded as granted. Close it — one by one or with «Revoke all».",
        empty: "No offboarded person holds active access.",
      },
      unknown: {
        title: "Unverified access",
        hint: "The source spreadsheet left this cell empty — it is unknown whether access was granted. Set «Granted» or «Revoked».",
        empty: "Nothing left to verify.",
      },
      active: {
        title: "Active access",
        hint: "Every granted access. Close any of them during offboarding or a role change.",
        empty: "No active access.",
      },
    },
  },
  esim: {
    title: "eSIM & numbers",
    subtitle: "Mirrors the «Bip + Esim» spreadsheet: one tab per sheet",
    tabs: { esim: "E-sim", bip: "Bip", eu: "EU", trash: "Trash", topup: "Top up" },
    number: "Number", qr: "QR", until: "Active until", purpose: "Purpose", status: "Status", drive: "File on Google Drive", driveShort: "Drive",
    active: "Active", pool: "Pool", archived: "Archived",
    topUp: "Needs top-up", topUpShort: "top up",
    open: "Open", add: "Add number",
    count: "Numbers: {n}",
    searchHint: "Number / @tg / nick / purpose",
  },
  status_person: { active: "Active", blocked: "Blocked", left: "Left", archive: "Archive", all: "All" },
  edit: {
    edit: "Edit", save: "Save", cancel: "Cancel", del: "Delete", yesDelete: "Yes, delete",
    saved: "Saved", deleted: "Deleted",
    handle: "Handle", number: "Number", label: "Label", note: "Note",
    addAccount: "Add account", dateExact: "Exact leave date",
  },
  signin: {
    title: "Sign in",
    subtitle: "Equipment inventory · Google access for the SD team",
    google: "Sign in with Google",
    sso: "Sign in with Keycloak",
    denied: "Access denied: your account is not on the SD team list.",
    error: "Sign-in failed. Please try again.",
    signout: "Sign out",
  },
};

export const DICT: Record<Locale, Dict> = { ru, uk, en };
